import { buildSvgString, type SvgStringOpts } from '../../svgString';

import { data } from './data';

export const AIStarSVG = (opts?: SvgStringOpts): string => buildSvgString(data, opts);

export default AIStarSVG;
